// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flightInfo__title-miPou";
var _3 = "city__airport-3WwZI";
var _4 = "footer__itemLabel-2TUcy";
var _5 = "flightInfo__value-1FSF4";
var _6 = "city__iata-35Cq0";
var _7 = "flightInfo-3LKIc";
var _8 = "flightInfo__departure-1V1aa";
var _9 = "city__time-2Hrx6";
var _a = "footer__itemValue-15LlI";
var _b = "airline__name-2-9gS";
export { _1 as "__esModule", _2 as "flightInfo__title", _3 as "city__airport", _4 as "footer__itemLabel", _5 as "flightInfo__value", _6 as "city__iata", _7 as "flightInfo", _8 as "flightInfo__departure", _9 as "city__time", _a as "footer__itemValue", _b as "airline__name" }
export default { "__esModule": _1, "flightInfo__title": _2, "city__airport": _3, "footer__itemLabel": _4, "flightInfo__value": _5, "city__iata": _6, "flightInfo": _7, "flightInfo__departure": _8, "city__time": _9, "footer__itemValue": _a, "airline__name": _b }
